import { nanoId } from '@/helpers'
import Vue from 'vue'

const inmobilized = () => {
  return {
    fileNumber: '',
    appraisalAmount: 0,
    invoiceAmount: 0
  }
}

export const SET_FILENUMBER = (state, { key, value }) => {
  state._[key].fileNumber = value
}

export const SET_APPRAISALAMOUNT = (state, { key, value }) => {
  state._[key].appraisalAmount = value
}

export const SET_INVOICEAMOUNT = (state, { key, value }) => {
  state._[key].invoiceAmount = value
}

export const ADD = (state, payload) => {
  let key = nanoId(8)
  state.list.push(key)
  if (!payload) payload = inmobilized()
  Vue.set(state._, key, Object.assign({}, payload))
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
